var map = {
	"./attribute-and-personality.vue": "0a07",
	"./brand-architecture.vue": "c4a6",
	"./brand-dna.vue": "f542",
	"./brand-values-and-positioning.vue": "80ee",
	"./design-principles.vue": "c46d",
	"./vision-mission-and-purpose.vue": "aa41"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4fe5";